import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IrbAppEvents } from '@irb/app.events';
import { IAlertDialogData } from '@irb/app.model';
import { AppService } from '@irb/app.service';
import {SecurityMasterService} from '@irb/irb-models/security-master/security-master.service';

@Component({ standalone: false,
  selector: 'irb-dialog-delete-component-securities',
  templateUrl: './dialog-delete-component-securities.component.html',
  styleUrls: ['./dialog-delete-component-securities.component.scss']
})
export class DialogDeleteComponentSecuritiesComponent implements OnInit {

  deleteSecurities: Array<any> = [];
  deleteContinueFunction: Function;
  deleteSecurity: any=[] ;
  securityDetails: any=[];


  constructor(public dialogRef: MatDialogRef<DialogDeleteComponentSecuritiesComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private as: AppService, private readonly securityMasterService:SecurityMasterService) { }

  ngOnInit(): void {
    this.checkSecurityStatus();
    this.getDeletedSecurities();
    this.deleteContinueFunction = this.data.deleteContinueFunction || null; 
  }

  getDeletedSecurities() {
    for (let i = 0; i < this.deleteSecurities.length; i++) {
      this.deleteSecurity = {
        securityId: this.deleteSecurities[i].securityId,
        versionId: this.deleteSecurities[i].versionId
      };
      this.securityDetails.push(this.deleteSecurity);
    }
  }

  checkSecurityStatus() {
    if (this.data.securityDeletedIds) {
      this.deleteSecurities = this.data.securityDeletedIds;
    }
  }

  close() {
    if (this.dialogRef.close !== undefined)
     this.dialogRef.close();
  }
  deleteSelectedSecurities() {
    this.deleteContinueFunction(this.deleteSecurities);
    this.close();
  }
}
